import { classNames } from '@/utils/helpers.ts'

interface Props {
  rootClassName?: string
  className?: string
}

export const LoadingBar = ({ className, rootClassName }: Props) => {
  return (
    <div
      className={classNames(
        'relative h-1 w-full overflow-hidden',
        rootClassName,
      )}
    >
      <div
        className={classNames(
          'absolute h-full w-1/5 animate-loading-progress-bar bg-primary-500',
          className,
        )}
      />
    </div>
  )
}
